/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable import/extensions */

import React from 'react';
import { Link } from "react-router-dom";
import BrandIcon from './BrandIcon';
import Button from '../elements/Button';
import linkedin from "../assets/images/hero/linkedin.png";

export default function Footer() {
  return (
    <div className="bg-gray-50 border-t border-gray-200 pb-6">
      <div className="container flex-col mx-auto">
        <div className="flex flex-col lg:flex-row mt-8 justify-center">
          <div className="w-1/3 flex-col ml-16 mr-8">
            <BrandIcon />
          </div>
          <div className="w-1/3 mt-0 ml-16 mr-0 sm:ml-0 sm:mr-5">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">Contact</h1>
            <p className="text-lg text-gray-400 font-light">
              Email : admin@chitragupta.co
            </p>
          </div>
          <div className="w-1/3 ml-16 sm:ml-0 mt-0">
            <h1 className="text-lg text-theme-blue pt-4 pb-2">Social</h1>

            {/* Company LinkedIn */}
            <Button
              href="https://www.linkedin.com/company/chitragupta-urban-tech/"
              type="link"
              target="_blank"
              className="flex items-center justify-start text-gray-400 hover:text-blue-600"
              isExternal
            >
              <img src={linkedin} alt="LinkedIn" className="w-6 h-6 mr-2" />
              Chitragupta Urban Tech (Company)
            </Button>

            {/* Co-founder 1 LinkedIn */}
            <Button
              href="https://www.linkedin.com/in/namanpaithankar"
              type="link"
              target="_blank"
              className="flex items-center justify-start text-gray-400 hover:text-blue-600 mt-2"
              isExternal
            >
              <img src={linkedin} alt="LinkedIn" className="w-6 h-6 mr-2" />
              Naman Paithankar (Co-Founder and CEO)
            </Button>

            {/* Co-founder 2 LinkedIn */}
            <Button
              href="https://www.linkedin.com/in/jayeshgolatkar"
              type="link"
              target="_blank"
              className="flex items-center justify-start text-gray-400 hover:text-blue-600 mt-2"
              isExternal
            >
              <img src={linkedin} alt="LinkedIn" className="w-6 h-6 mr-2" />
              Jayesh Golatkar (Co-Founder and CTO)
            </Button>
          </div>
        </div>

        <div className="flex-col text-center mt-7">
          <p className="text-sm text-gray-400 font-light">
            Copyright 2024 - All rights reserved - Chitragupta.co
          </p>
          <div className="flex-row">
            <p className="inline-block text-lg text-gray-400 font-light">
              Made in Bharat 🇮🇳 by&nbsp;
            </p>
            <Button
              href="https://www.linkedin.com/company/chitragupta-urban-tech/"
              type="link"
              target="_blank"
              className="text-m text-orange-600 font-light"
              isExternal
            >
              Chitragupta.co
            </Button>
            &nbsp;&nbsp;
            <Link
              to="/privacy-policy"
              className="text-blue-500 hover:text-blue-700 font-semibold"
            >
              Privacy Policy
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
